import { Tax } from '../Taxes/Model';
import { ReceiptLayout } from '../ReceiptLayouts/Model';
import Headboard from '../Headboards/Headboard';
import { PriceExtra } from '../../Models/PriceExtra';
import { StretchPrice } from './StretchPrice';
import AfiliatePrice from '../Prices/AfiliatePrice';
export default class Stretch {
    constructor(props) {
        var _a;
        this.prices = [];
        this.disabledDays = [];
        this.vueltaPrices = [];
        Object.assign(this, props);
        /*this.hora = {hours: props.hours, minutes: props.minutes}*/
        if (props.prices) {
            this.prices = props.prices.map((value) => new StretchPrice(value));
        }
        if (props.receiptLayout)
            this.receiptLayout = new ReceiptLayout(props.receiptLayout);
        if (props.tax)
            this.tax = new Tax(props.tax);
        if (!props.horasIda)
            this.horasIda = [];
        if (!props.horasVuelta)
            this.horasVuelta = [];
        if (props.headboard)
            this.headboard = new Headboard(props.headboard);
        // this.mapSite = new MapSite()
        /*if (props.mapSite && props.mapSite.seatZones) {
          this.mapSite.seatZones = props.mapSite.seatZones.map(seatZone => new SeatZone(seatZone))
        } else {
          this.mapSite.seatZones = []
        }*/
        if (props.stretchOtas) {
            this.stretchOtas = props.stretchOtas.map((value) => new StretchOta(value));
        }
        this.afiliatePrices = (_a = props.afiliatePrices) === null || _a === void 0 ? void 0 : _a.map((price) => new AfiliatePrice(price));
        // console.log('Stretch - constructor - props: ', this)
    }
}
export class StretchOta {
    constructor(props) {
        Object.assign(this, props);
    }
}
export const getSaleExtra = (stretch) => {
    return stretch.extras
        .filter((extra) => !extra.disabled_at)
        .map((extra) => {
        return {
            name: extra.name,
            price: new PriceExtra({
                id: extra.id,
                name: extra.name,
                price: extra.price,
                tax: extra.tax,
                description: extra.description,
                isIncluded: extra.isIncluded,
                extra: extra
            }),
            quantity: 0,
        };
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/Stretch.ts
// module id = 58
// module chunks = 0